import { useState } from 'react';
import { useNFTs } from './hooks/useNFTs';
import NFTGrid from './components/NFTGrid';
import NFTDetailModal from './components/NFTDetailModal';
import { NFTData } from './types';

function App() {
  const { groups, loading, error, total, completed } = useNFTs();
  const [selectedNFT, setSelectedNFT] = useState<NFTData | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleNFTClick = (nft: NFTData) => {
    setSelectedNFT(nft);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedNFT(null);
  };

  return (
    <div className="app">
      <header className="header">
        <div className="container header-inner">
          <div>
            <h1 className="title">🐙 Octopus NFT Gallery</h1>
          </div>
        </div>
      </header>

      <main className="container main">
        {loading && (
          <div className="loading-wrap">
            <span className="loading-spinner"></span>
            <div className="loading-text">Loading NFTs… {completed}/{total}</div>
            <div className="progress">
              <div className="progress-bar" style={{ width: total > 0 ? `${Math.round((completed/Math.max(1,total))*100)}%` : '0%' }} />
            </div>
          </div>
        )}

        {error && (
          <div className="error-box">
            <div className="error-title">Error loading NFTs</div>
            <div className="error-message">{error}</div>
          </div>
        )}

        {!loading && !error && (
          <div className="groups">
            {groups.length === 0 && (
              <div className="empty">No NFTs found. The collection might be empty.</div>
            )}
            {groups.map((g, idx) => (
              <section key={g.address} className="group">
                <div className="group-header">
                  <div className="group-title">Deployment {idx + 1} — <a className="address-link" href={`https://sepolia.etherscan.io/address/${g.address}`} target="_blank" rel="noopener noreferrer">{g.address}</a></div>
                </div>
                <NFTGrid nfts={g.nfts} onNFTClick={handleNFTClick} />
              </section>
            ))}
          </div>
        )}
      </main>

      <NFTDetailModal nft={selectedNFT} isOpen={isModalOpen} onClose={handleCloseModal} />

      <footer className="footer">
        <div className="container footer-inner">
          <p className="small">
            Powered by Ethereum • View on{' '}
            <a href="https://sepolia.etherscan.io" target="_blank" rel="noopener noreferrer">Etherscan</a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
